export default function formatDate(
  date: Date | number | string,
  joinString = '-',
): string {
  return new Date(date)
    .toISOString()
    .replace(/T.*/, '')
    .replace(/-/g, joinString);
}
